export const PRODUCT_PRICE_SUGGESTION_TABLE = "productPriceSuggestions"
export const PRODUCT_PRICE_SUGGESTION_TABLE_SCHEMA =
  "id, companyId, targetId, syncId"
